<template>
    <div id="student-profile" class="card h-100">
        <div class="card-body">
            <h5 class="card-title"><i class="fas fa-user"></i> My Information</h5>
            <div class="card-text">
                <div class="mb-3 text-center">
                    <img class="img-thumbnail student_avatar" :src="getAvatar()" alt="avatar">
                </div>
                <div class="container-fluid pl-0 pr-0">
                    <div class="row">
                        <div class="col-12 col-lg-5 font-weight-bold">
                            Name
                        </div>
                        <div class="col-12 col-lg-7 text-lg-right text-muted">
                            {{ user.name || "N/A" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'student-profile',
    props: {
        user: {
            type: Object
        }
    },
    methods: {
        getAvatar() {
            if (this.user && this.user.photo) {
                return `data:image/jpeg;base64,` + btoa(this.user.photo);
            }

            return `./../src/assets/avatar/no_profile.png`;
        }
    }
}
</script>

<style scoped>
.student_avatar {
    width: 300px;
    height: 300px;
    object-position: center;
    object-fit: cover;
}
</style>